var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "create-invoice__popup" }, [
    _c("div", { staticClass: "create-invoice__popup-title" }, [
      _vm._v(_vm._s(_vm.i18n.cont_create_invoice()))
    ]),
    _vm._v(" "),
    _c(
      "form",
      { staticClass: "create-invoice__form", attrs: { novalidate: "" } },
      [
        _c(
          "div",
          { staticClass: "create-invoice__row" },
          [
            _vm.invoiceAsset
              ? _c("select-field", {
                  staticClass: "create-invoice__field",
                  attrs: {
                    value: _vm.invoiceAsset,
                    values: Object.keys(_vm.accountBalances)
                  },
                  on: {
                    input: function($event) {
                      return _vm.$emit(_vm.events.assetChange, $event)
                    }
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _c("input-field", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required",
                  expression: "'required'"
                }
              ],
              staticClass: "create-invoice__field",
              attrs: {
                label: _vm.i18n.cont_invoice_number(),
                name: "invoice-number"
              },
              model: {
                value: _vm.form.number,
                callback: function($$v) {
                  _vm.$set(_vm.form, "number", $$v)
                },
                expression: "form.number"
              }
            }),
            _vm._v(" "),
            _c("input-field", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required",
                  expression: "'required'"
                }
              ],
              staticClass: "create-invoice__field",
              attrs: {
                label: _vm.i18n.cont_invoice_amount({
                  asset: _vm.invoiceAsset
                }),
                name: "invoice-amount"
              },
              model: {
                value: _vm.form.amount,
                callback: function($$v) {
                  _vm.$set(_vm.form, "amount", $$v)
                },
                expression: "form.amount"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "create-invoice__row" }, [
          _c(
            "div",
            { staticClass: "create-invoice__field-bottom" },
            [
              _c("h3", { staticClass: "create-invoice__field-title" }, [
                _vm._v(_vm._s(_vm.i18n.lbl_document()))
              ]),
              _vm._v(" "),
              _c("file-field", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  }
                ],
                attrs: {
                  fileType: "image",
                  name: "invoice-file",
                  type: _vm.documentTypes.invoice
                },
                model: {
                  value: _vm.documents.invoice,
                  callback: function($$v) {
                    _vm.$set(_vm.documents, "invoice", $$v)
                  },
                  expression: "documents.invoice"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "create-invoice__field-bottom" },
            [
              _c("h3", { staticClass: "create-invoice__field-title" }, [
                _vm._v(_vm._s(_vm.i18n.lbl_note()))
              ]),
              _vm._v(" "),
              _c("textarea-field", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  }
                ],
                attrs: { name: "invoice-note" },
                model: {
                  value: _vm.form.note,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "note", $$v)
                  },
                  expression: "form.note"
                }
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "create-invoice__submit-wrapper" },
          [
            _c(
              "md-button",
              {
                staticClass: "md-primary",
                attrs: { disabled: _vm.isPending },
                on: { click: _vm.submit }
              },
              [_vm._v(_vm._s(_vm.i18n.lbl_submit()))]
            )
          ],
          1
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-914939d4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-914939d4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/contracts/index/modals/Contracts.CreateInvoice.vue
// module id = tZl+
// module chunks = 1